import { Controller } from 'stimulus'
import { dispatchPlay } from '~/common/voice_playback'

// Generic trigger for text-to-speech playback. Use whenever the text to read is
// available at server render time (forum post bodies, lesson content, etc.).
//
// For dynamic text sources (e.g. streamed chat-bot messages), import dispatchPlay
// directly from common/voice_playback and gather the text yourself.
export default class extends Controller {
  static values = {
    text: String,
    sourceId: String,
  }

  async play(event) {
    event?.preventDefault?.()
    if (!this.textValue) return

    try {
      await dispatchPlay({ text: this.textValue, sourceId: this.sourceIdValue })
    } catch (error) {
      console.error('Voice playback trigger failed:', error)
    }
  }
}
